// 2) Third-party library imports
import { Quill } from 'react-quill-new';
import { get } from 'lodash-es';

// 3) Local imports
// Constants
import { CONTENT_CUSTOMIZATION_EDITOR_FORMAT } from '../../constants/contents';

const BlockBlot: any = Quill.import("blots/block");

export class CustomBlock extends BlockBlot {
    static create(value: any) {
        const node = super.create(value);
        const whitelist = get(node, 'parent.whitelist');

        if (get(whitelist, CONTENT_CUSTOMIZATION_EDITOR_FORMAT)) {
            node.setAttribute('app-customization', 'true');
        }
        return node;
    }

    insertBefore(blot: any, ref: any) {
        super.insertBefore(blot, ref);
        const whitelist = get(this, 'parent.whitelist');

        if (get(whitelist, CONTENT_CUSTOMIZATION_EDITOR_FORMAT)) {
            this.domNode.setAttribute('app-customization', 'true');
        }
    }
}

CustomBlock.blotName = 'custom-block';
CustomBlock.tagName = 'DIV';

Quill.register(CustomBlock);